import Error from 'assets/icons/error.svg';

const EmptyDataScreen = ({ className }: { className: string }) => {
  return (
    <div
      className={`flex flex-col justify-center items-center w-full h-[400px] gap-4 ${className}`}
    >
      {/* <div className='w-10 h-10 text-2xl rounded-full border-[2px] grid place-content-center border-gray-500 text-gray-500 font-sans '>
          !
        </div> */}
      <img src={Error} alt='error' />
      <p className='text-center text-2xl font-light'>
        There&apos;s not enough data to display this chart.
      </p>
      <div className=' text-center text-gray-500 text-base font-light leading-tight max-w-[420px]'>
        We set a minimum sample size in order to maintain data fidelity and
        privacy - please adjust the filters you’re using.
      </div>
    </div>
  );
};

export default EmptyDataScreen;
